import '../styles/main.css';
import 'materialize-css';
import {Card, CardTitle} from 'react-materialize';
import { Link } from 'react-router-dom';

export default function product() {
    return (
            <Card
                actions={[<Link to='/' style={{color: '#2f4cdb', margin: '0 0 0 9rem'}}>Add To Cart</Link>]}
                className='product-card'
                header={<CardTitle image="https://materializecss.com/images/sample-1.jpg"></CardTitle>}
            >
                <div className='card-container-one'>
                    <div className='brand-name'>H & M</div>
                    <div className='price'>
                        <span className='offer-applied-price'>Rs. 1500 </span> 
                        <span className='original-price'>Rs. 399 </span>
                        <span className='offer'>(10% OFF)</span>
                    </div>        
                </div>
                <div className='description'>Solid Round Neck T-Shirt</div>
            </Card>
    )
}